import {useQuery} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {useClientV2} from "../../../../utils/hooks";
import {GetSubscriptionApiResponse} from "./types";
import {GET_STORE_SUBSCRIPTION_RQ_KEY} from "../constants";
import {normalizeGetSubscriptionResponse} from "./normalize";

export const useGetSubscriptionApi = (subscriptionId?: number) => {
  const client = useClientV2();

  return useQuery<
    GetSubscriptionApiResponse,
    AxiosError<{status: boolean; message: string}>
  >({
    queryKey: [GET_STORE_SUBSCRIPTION_RQ_KEY, String(subscriptionId)],
    queryFn: async () => {
      if (!subscriptionId) {
        throw new Error("Subscription id is required.");
      }
      const envelope = await client(`subscriptions/${subscriptionId}`);
      const body = envelope as {data?: unknown};
      return normalizeGetSubscriptionResponse(body?.data);
    },
    enabled: !!subscriptionId,
  });
};
